<template>
  <div>
    <em>{{ screenSet.name }}</em>
    <b-tooltip label="Save currently applied screens.">
      <b-icon
        pack="fas"
        icon="save"
        label="Save Screens"
        v-bind:type="isSaved ? '': 'is-primary'"
        v-on:click.native="maybePrompt"
      />
    </b-tooltip>
    <b-tooltip label="Save as a new set of screens.">
      <b-icon
        pack="fas"
        icon="file"
        label="New Screen Set"
        v-on:click.native="newScreenSet"
        v-if="screenSet.id"
      />
    </b-tooltip>
  </div>
</template>

<script>
import eventBus from '@frontend/shared/EventBus.js';

export default {
  data() {
    return {
      savingNew: false,
    }
  },
  props: {
    mode: String,
    isSaved: Boolean,
    screens: Object,
    screenSet: Object,
    valuesSource: Object,
    callback: Function,
  },
  computed: {
    activeScreens: function() {
      return this.screens.a.filter((itm) => {
        return itm.userPercentile > 0;
      });
    }
  },
  methods: {
    maybePrompt: function() {
      if (this.screenSet.id) {
        this.update();
      }
      else {
        this.prompt();
      }
    },
    newScreenSet: function() {
      this.savingNew = true;
      this.prompt();
    },
    maybeAttachValuesToSource: function() {
      let sourceId;
      let pathName;
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('values_from')) {
        sourceId = urlParams.get('values_from');
      }
      if (this.valuesSource) {
        sourceId = this.valuesSource.id;
      }

      if (sourceId) {
        pathName = sourceId.startsWith('shareowner_') ? 'portfolios' : 'prospects';
        fetch(`/api/v1/${pathName}/${sourceId}/`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
          body: JSON.stringify({
            'screen_sets': [{id: this.screenSet.id}],
          }),
        }).then((response) => {
          return response.json();
        }).then((data) => {
          eventBus.$emit('WorkflowCard:client-updated', {})
        });
      }
    },
    update: function() {
      fetch(`/api/v1/screen_sets/${this.screenSet.id}/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.$root.$data.csrfToken,
        },
        body: JSON.stringify({
          'name': this.screenSet.name,
          'metric_thresholds': this.activeScreens.map((itm) => {
            return {
              'metric_description_id': itm.id,
              'threshold': itm.userPercentile / 100,
            }
          })
        }),
      }).then((response) => {
        if (!response.ok) {
          throw new Error(`Server error while trying to update screenset: ${response.status} ${response.statusText}`);
        }
        return response.json();
      }).then((data) => {
        this.callback.call(this, true);
        this.savingNew = false;
        this.$buefy.toast.open('Saved!');
        this.maybeAttachValuesToSource();
      }).catch((error) => {
        this.$buefy.toast.open({
          message: 'Something went wrong while trying to update the screenset. Please try again or contact support.',
          type: 'is-danger',
        });
        throw error;
      });
    },
    prompt: function(errorMsg) {
      let message;
      if (errorMsg) {
        message = `
          <p class="notification is-warning">Error saving the screen set: ${errorMsg}</p>
          Enter a name for this set of screens:
        `
      }
      else {
        message = 'Enter a name for the set of currently applied screens:';
      }

      this.$buefy.dialog.prompt({
        message: message,
        inputAttrs: {
            placeholder: 'Human rights & environment focused',
            value: this.screenSet.is_dndx ? this.screenSet.name : null,
            maxlength: 200
        },
        trapFocus: true,
        closeOnConfirm: false,
        confirmText: 'Save',
        onConfirm: (value, {close}) => {
          this.$buefy.toast.open(`Saving as: ${value}...`)
          fetch('/api/v1/screen_sets/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': this.$root.$data.csrfToken,
            },
            body: JSON.stringify({
              'name': value,
              'metric_thresholds': this.activeScreens.map((itm) => {
                return {
                  'metric_description_id': itm.id,
                  'threshold': itm.userPercentile / 100,
                }
              })
            }),
          }).then((response) => {
            if (response.ok) {
              response.json().then((data) => {
                this.screenSet.name = value;
                this.screenSet.id = data.id;
                this.callback.call(this, true);
                this.$buefy.toast.open('Saved!');
                this.maybeAttachValuesToSource();
                close();
              });
            }
            else {
              response.json().then((data) => {
                close();
                this.callback.call(this, false);
                this.prompt(data.error);
              });
            }
          });
        }
      });
    }
  },
  created: function() {
    window.onbeforeunload = (e) => {
      if (!this.isSaved) {
        return 'You have unsaved changes to your list of screens, are you sure you want to leave?';
      }
    };
  }
}
</script>

<style scoped>
button {
  disblay: block;
}
</style>
